import { render } from "./LanguagePicker.vue?vue&type=template&id=98f02c38&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"

import "./LanguagePicker.vue?vue&type=style&index=0&id=98f02c38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f02c38"]])

export default __exports__